const authentication = require('../../../react-azure-adb2c2').default;







export const list = (values: any) => {

  // const url = process.env.REACT_APP_API_BASE_URL + `/v1/seisan/follow/list`;

  // const url = `https://homestation-pm-api.azurewebsites.net/v1/seisan/follow/list`;
  // let url = `http://localhost:5000/v1/owner/remittances/list`;
  const url = process.env.REACT_APP_API_BASE_URL + `/v1/owner/remittances/list`;
  const token = authentication.getAccessToken();
  // console.log(JSON.stringify(values))
  // alert(JSON.stringify(values))


  return fetch(url, {
    method: 'get',
    // body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};






export const send = (values: any) => {
  // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/update`;
  // let url = `http://localhost:5000/api/v1/kyousais/update`;
  // alert(url)
  const url = process.env.REACT_APP_API_BASE_URL + `/v1/owner/remittances/send`;
  // let url = `http://localhost:5000/v1/owner/remittances/send`;
  const token = authentication.getAccessToken();
  // alert(JSON.stringify(values))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};


